import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9f31a7aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "header"
}
const _hoisted_2 = { class: "rel flex-cen" }
const _hoisted_3 = { class: "viewport flex-cen routes rel guideDom-pure-all-1" }
const _hoisted_4 = {
  key: 0,
  class: "abs new-tag"
}
const _hoisted_5 = { class: "line" }

import { t } from '@/plugins/i18n'
import ToolBar from '@/components/bussiness/ToolBar.vue'
import Search from '@/components/bussiness/Search.vue'
import { isD2C, isEN, isJA } from '@/store'
import { ref, computed, watch } from 'vue'
import type { Ref, ComputedRef } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { bury } from '@/util/useBury'
import { TaEvent, taTrack } from '@/util/buryingPoint'

// const d2dUrl = computed(() => process.env.VUE_APP_D2D_URL)
interface Tab {
  label: string
  name: string
  value: string
  children?: any[]
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const route = useRoute()
const store = useStore()
/** 是否展示搜索 */
const showSearch = ref(true)

/** 是否主账号 */
const isMain = computed(() => store.getters.user?.accountType !== 2)

/** 切换tab */
const clickTab = (i: number) => {
  bury(['ALL_Click_MyChannel', 'ALL_Click_ECBuy', 'ALL_Click_MarketBuy'][i])
  taTrack({
    event: TaEvent.BTN_CLICK,
    value: {
      position: ['my_channel', 'pure_buy', 'market_buy'][i]
    }
  })
  if (!store.getters.isLogin && i === 0) {
    taTrack({
      event: TaEvent.PUPUP_WINDOW,
      value: {
        position: 'my_channel'
      }
    })
  }
}

watch(() => route.query, () => {
  // 日本且有国家站标识的隐藏
  showSearch.value = !(isJA() && route.query.national)
}, { immediate: true })

// const logoSrc = computed(() => {
//   // return isD2C() ? require('@/assets/image/logos/home-d2c.png') : require('@/assets/image/logos/home-b2b.png')
//   return isJA() ? require('https://static-jp.theckb.com/static-asset/client/homelogo.png') : require('https://static-s.theckb.com/BusinessMarket/Client/homelogo.png')
// })

const temp: Tab[] = store.state.bussiness.Channels
const tabs = computed(() => {
  return temp.map((v) => {
    const item = { ...v }
    item.name += '_' + store.getters.site
    return item
  })
})
const toRawName = (name: any) => name?.slice(0, -4)

const tab: ComputedRef<Tab | undefined> = computed(() => {
  return tabs.value.find(
    (v) =>
      // 路由改造，多了/ko/en/ja前缀，全等改为Includes
      (route.name as string).includes(v.name) ||
      (v.children && v.children.includes(toRawName(route.name)))
  )
})

watch(
  tab,
  (v) => {
    if (v) {
      store.commit('bussiness/schannel', v.value)
    }
  },
  { immediate: true }
)

const showHeader = computed((): boolean => route.path.includes('index'))

const tabRef: Ref<any> = ref({})
const x = computed(() => {
  const el = tabRef.value[tab.value?.name || '']
  if (!el) return { left: '-1000px' }
  const { left, width } = el.getBoundingClientRect()
  return {
    transform: `translateX(${left + width / 2}px)`,
    none: store.state.observe.resize
  }
})

const tstn = ref('')
watch(
  showHeader,
  (v) => {
    if (v) {
      tstn.value = ''
      setTimeout(() => {
        tstn.value = 'tstn'
      }, 1000)
    }
  },
  { immediate: true }
)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ToolBar),
    _createVNode(_Transition, {
      name: _unref(store).getters.scroll > 100 ? '' : 'move'
    }, {
      default: _withCtx(() => [
        (_unref(showHeader))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("nav", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabs), (v, i) => {
                    return (_openBlock(), _createBlock(_component_router_link, {
                      key: v.label,
                      onClick: ($event: any) => (clickTab(i)),
                      class: _normalizeClass(["btn rel", { active: v === _unref(tab) }]),
                      to: v,
                      style: _normalizeStyle({ marginLeft: i === 0 && _unref(isEN)() ? '130px' : '' })
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          ref: (el) => (tabRef.value[v.name] = el)
                        }, _toDisplayString(_unref(t)(v.label)), 513),
                        (v.value === '1')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_4, "NEW"))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["onClick", "class", "to", "style"]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["block", tstn.value]),
                    style: _normalizeStyle(_unref(x))
                  }, null, 6)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["name"]),
    (showSearch.value)
      ? (_openBlock(), _createBlock(Search, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})